import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// TODO: Put all prove data here

export interface ProveInfoResponse {
  status: string | number;
  description: string;
}

export interface ProveInfoState {
  statuses: string;
  descriptions: string;
}

const initialState: ProveInfoState = {
  statuses: '',
  descriptions: '',
};

const proveErrorInfo = createSlice({
  name: 'proveInfo',
  initialState: initialState,
  reducers: {
    setProveErrorInfo: (state, { payload }: PayloadAction<Partial<ProveInfoResponse>>) => {
      if (!state.statuses.length) {
        state.statuses += payload.status;
        state.descriptions += payload.description;
      } else {
        state.statuses += ` | ${payload.status}`;
        state.descriptions += ` | ${payload.description}`;
      }
    },
  },
});

export const { setProveErrorInfo } = proveErrorInfo.actions;
export default proveErrorInfo.reducer;
